import React from 'react';
import { ShoppingBag } from 'react-feather';
import { useCart } from '../cart/CartContext';

export default function CartIcon({ onClick }) {
  const { itemCount } = useCart();

  return (
    <button type="button" className="cart-icon-btn" onClick={onClick} aria-label="Open cart">
      <ShoppingBag />
      {itemCount > 0 && <span className="cart-count-badge">{itemCount}</span>}
    </button>
  );
}
